import {
  ACTIONS_TEXT,
  ALERT_MODAL,
  DELETE_MODAL,
} from '../../shared/shared-constants';

export enum ColumnIds {
  ROUTE = 'loop',
  ACCESS = 'id',
  UAP = 'uapPublicId',
  AVAILABILITY = 'hoursOfOperation',
  CITY = 'city',
  CONTACT = 'phoneNumber',
  STATUS_COL = 'uapStatus',
  ACTIONS = 'action',
}

export const ColumnText = {
  ROUTE: $localize`Route Id`.toUpperCase(),
  ACCESS: $localize`Access Points`.toUpperCase(),
  UAP: $localize`UAP ID`.toUpperCase(),
  AVAILABILITY: $localize`Availability`.toUpperCase(),
  CITY: $localize`City`.toUpperCase(),
  CONTACT: $localize`Contact`.toUpperCase(),
  STATUS: $localize`Status`.toUpperCase(),
  ACTIONS: ACTIONS_TEXT,
};

export const DAYS_OF_WEEK = {
  All: $localize`all-selected`,
  SUNDAY: $localize`Sunday`,
  MONDAY: $localize`Monday`,
  TUESDAY: $localize`Tuesday`,
  WEDNESDAY: $localize`Wednesday`,
  THURSDAY: $localize`Thursday`,
  FRIDAY: $localize`Friday`,
  SATURDAY: $localize`Saturday`,
};

export const STATUS = {
  ACTIVE: `Active`.toUpperCase(),
  INACTIVE: `Inactive`.toUpperCase(),
  CANCELLED: `Cancelled`.toUpperCase(),
  PENDING: `Pending`.toUpperCase(),
  INCOMPLETE: `Incomplete`.toUpperCase(),
  SUSPENDED: `Suspended`.toUpperCase(),
  ACTIVE_UNAVAILABLE: `Active-Unavailable`.toUpperCase(),
  TERMINATED: `Terminated`.toUpperCase(),
  UNKNOWN: `Unknown`.toUpperCase(),
};

export const DISPLAY_TEXT = {
  WELCOME_TEXT: $localize`Access Points`,
  ALL_TEXT: 'All',
  MODAL: {
    ...ALERT_MODAL,
    BODY: $localize`Selected Route ID can't be deleted. All pickups must be unassigned from Route prior to removal.`,
  },
  DELETE_MODAL: DELETE_MODAL,
  SEARCH_HERE: $localize`Search Here`,
};
export const EXCEL_FILE_NAME = 'access-point-data';
export const ROUTE_TEXT = '%n (%s)';
